import React, { useState } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/solid";

export default function ToggleTextComponent({
  title,
  body,
}: {
  title: string;
  body: string;
}) {
  const [isVisible, setIsVisible] = useState(false);

  const toggleVisibility = () => {
    setIsVisible(!isVisible);
  };

  return (
    <div className="toggle-text-component px-4">
      {body && (
        <>
          <button onClick={toggleVisibility} className="mt-2 flex items-center">
            {title}
            <span
              className={`ml-2 transform ${isVisible ? "rotate-90" : "rotate-0"}`}
              style={{ transition: "transform 0.2s" }}
            >
              <ChevronRightIcon className="h-4 w-4 text-blue-500" />
            </span>
          </button>
          {isVisible && (
            <div
              dangerouslySetInnerHTML={{ __html: body }}
              className="ql-editor transcript-dropdown mt-2 p-4 border border-black-300 shadow-lg bg-white max-h-60 overflow-y-auto"
            />
          )}
        </>
      )}
    </div>
  );
}
